<div>
	@if (showForm()) {
		@if (edit(); as edit) {
			<nz-tabs>
				<nz-tab nzTitle="Edit Unit">
					<app-setup-wizard-unit-form
						[courseUuid]="edit.before!.course_uuid!"
						[loading]="loading()"
						[edit]="edit.after || edit.before || null"
						(onClear)="onFormClear()"
						(onSubmit)="onFormSubmit($event)"
					></app-setup-wizard-unit-form>
				</nz-tab>
				<nz-tab nzTitle="Add Lesson">
					<app-setup-wizard-lesson-form
						[unitUuid]="edit.before!.unit_uuid!"
						[loading]="loading()"
						(onClear)="onFormClear()"
						(onSubmit)="onLessonFormSubmit($event)"
					></app-setup-wizard-lesson-form>
				</nz-tab>
			</nz-tabs>
		} @else {
			<h1>Edit is missing...</h1>
		}
	} @else {
		<div class="top-buttons">
			<button
				nz-button
				nzType="primary"
				(click)="onAdd()"
				class="add-button"
				[disabled]="true"
				nz-tooltip="To add a new unit go to the course tab and edit the course you want to add the unit to."
			>
				Add
			</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.units"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-units-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-units-table>
</div>
